/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {Component, ElementRef, Input, inject} from '@angular/core';

import {IxModule} from '@siemens/ix-angular';
import {FormFieldAttribute} from '../../../../../models/FormCategory';

@Component({
  selector: 'app-key-value',
  imports: [IxModule],
  templateUrl: './key-value.component.html',
  styleUrl: './key-value.component.scss',
})
export class KeyValueComponent {
  private readonly elementRef = inject(ElementRef);

  @Input() icon?: string;
  @Input() attribute?: FormFieldAttribute;
  @Input() label?: string;
  @Input() value?: any;

  get hasCustomValue(): boolean {
    return !!this.elementRef.nativeElement.querySelector(
      '[slot="custom-value"]',
    );
  }
}
